import { Component, inject } from '@angular/core';
import { SmartAssistantDateFormat } from '@iota/inh-core-v1-management-client';
import { SMART_ASSISTANT_DATE_FORMAT_LABELS } from 'src/app/shared/constants-and-enums/smart-assistant-types';
import { SmartAssistantImportService } from '../smart-assistant-import.service';

@Component({
    standalone: false,
    selector: 'app-smart-assistant-column-mapping-step',
    templateUrl: './smart-assistant-column-mapping-step.component.html'
})
export class SmartAssistantColumnMappingStepComponent {
    readonly service = inject(SmartAssistantImportService);

    dateFormats = Object.values(SmartAssistantDateFormat);
    dateFormatLabels = SMART_ASSISTANT_DATE_FORMAT_LABELS;

    updateColumnMapping(key: string, event: Event & { target: HTMLSelectElement }): void {
        this.service.updateColumnMapping(key, event?.target?.value);
    }

    updateDateFormat(key: string, event: Event & { target: HTMLSelectElement }): void {
        const format = (event?.target?.value || null) as SmartAssistantDateFormat | null;
        this.service.updateDateFormat(key, format);
    }
}
